import { OnlineSales } from 'gw-edge-client';
import { type BankAccountStatusDTO } from 'gw-edge-client/dist/types/dto/pc/top/edge/capabilities/onlinesales/dto/payment';

export const useValidateBankAccountData = (): {
    validateBankAccountData: (
        registrationNr: string,
        accountNr: string
    ) => Promise<BankAccountStatusDTO>;
} => {
    const validateBankAccountData = async (
        registrationNr: string,
        accountNr: string
    ): Promise<BankAccountStatusDTO> => {
        return await OnlineSales.validateBankAccountData(registrationNr, accountNr);
    };

    return { validateBankAccountData };
};
